import React, { useEffect, useState, useRef } from 'react';
import api from '../lib/api';

/**
 * Thin horizontal rolling ticker. Each item = one UNIQUE symbol with today's realized
 * % gain/loss (de-duplicated — counted from bot signals once, not per follower).
 * Green positive / red negative.
 */
export default function RollingTicker({ refreshMs = 30000 }) {
  const [items, setItems] = useState([]);
  const lastFetchRef = useRef(0);

  useEffect(() => {
    let dead = false;
    const fetchOnce = async () => {
      try {
        const { data } = await api.get('/public/live_today');
        if (!dead) setItems(data.ticker || []);
        lastFetchRef.current = Date.now();
      } catch (_) { /* keep last */ }
    };
    fetchOnce();
    const id = setInterval(fetchOnce, refreshMs);
    return () => { dead = true; clearInterval(id); };
  }, [refreshMs]);

  const rendered = items.length ? items : [
    { symbol: 'WAITING FOR LIVE DATA', pct: null, status: '' },
  ];
  const doubled = [...rendered, ...rendered];

  return (
    <div
      data-testid="rolling-ticker"
      className="relative w-full overflow-hidden border-y border-[rgba(201,162,75,0.16)] bg-[#101012]"
    >
      <div className="ticker-track flex items-center gap-10 py-2.5 whitespace-nowrap">
        {doubled.map((it, idx) => {
          const pct = typeof it.pct === 'number' ? it.pct : null;
          const isOpen = it.status === 'open';
          let cls = 'text-[#A99563]';
          let formatted = '—';
          if (isOpen) {
            cls = 'gold-text';
            formatted = 'OPEN';
          } else if (pct !== null) {
            cls = pct >= 0 ? 'pnl-positive' : 'pnl-negative';
            formatted = `${pct >= 0 ? '+' : '−'}${Math.abs(pct).toFixed(2)}%`;
          }
          return (
            <span key={`${it.symbol}-${idx}`} className="inline-flex items-center gap-2 font-mono text-[11px] tracking-wide">
              <span className="gold-text">{it.symbol}</span>
              <span className={cls}>{formatted}</span>
              <span className="h-2 w-px bg-[rgba(201,162,75,0.16)]" />
            </span>
          );
        })}
      </div>
    </div>
  );
}
